'use client';

import { FC, PropsWithChildren, useMemo, useState } from 'react';

import { PortalUser } from '@ravago/shared/page-data/models/elements';

import { PortalUsersContext } from '../context/portal-users-context';

interface Props extends PropsWithChildren {
   initialPortalUsers?: PortalUser[];
}

export const PortalUsersProvider: FC<Props> = ({ initialPortalUsers = [], children }) => {
   const [portalUsers, setPortalUsers] = useState<PortalUser[]>(initialPortalUsers);

   const value = useMemo(
      () => ({
         portalUsers,
         setPortalUsers
      }),
      [portalUsers]
   );

   return <PortalUsersContext.Provider value={value}>{children}</PortalUsersContext.Provider>;
};
